import {requestWrapper} from "@/js/requestWrapper";

const baseUrl = process.env.VUE_APP_API_URL;

const defaultHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json;charset=UTF-8'
};

//#region CRUD

export async function listUsersAsync() {
  return await requestWrapper(async () => await fetch(`${baseUrl}/api/users`, {
      headers: defaultHeaders,
      credentials: 'include',
      method: 'GET'
  }))
}

export async function getUserAsync(id) {
  return await requestWrapper(async () => await fetch(`${baseUrl}/api/users/${id}`, {
    headers: defaultHeaders,
    credentials: 'include',
    method: 'GET'
  }))
}

export async function updateUserAsync(id, user) {
  return await requestWrapper(async () => await fetch( `${baseUrl}/api/users/${id}`, {
    headers: defaultHeaders,
    credentials: 'include',
    method: 'PUT',
    body: JSON.stringify(user),
  }))
}

export async function deleteUserAsync(id) {
    return await requestWrapper(async () => await fetch(`${baseUrl}/api/users/${id}`, {
        headers: defaultHeaders,
        credentials: 'include',
        method: 'DELETE'
    }))
}

//#endregion

export async function confirmUserAsync(id, token, password) {
  const response = await fetch(`${baseUrl}/api/users/confirm-email/${id}`, {
    headers: {
        'Content-Type': 'text/plain;charset=UTF-8',
        token,
        password,
    },
    credentials: 'include',
    method: 'POST',
  });

  return response.ok;
}

export async function resetPasswordAsync(id, token, newPassword) {
  const response = await fetch(`${baseUrl}/api/users/reset-password/${id}`, {
    headers: {
      'Content-Type': 'text/plain;charset=UTF-8',
      Password: newPassword,
      Token: token
    },
    credentials: 'include',
    method: 'POST'
  });

  return response.ok;
}

export async function createUserAsync(user) {
  if (!user) {
    return;
  }

  return await requestWrapper(async () => await fetch(`${baseUrl}/api/users/`, {
    headers: defaultHeaders,
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(user)
  }))
}


export async function loginUserAsync(credentials) {
  const response = await fetch(`${baseUrl}/api/users/login`, {
    headers: defaultHeaders,
    method: "POST",
    credentials: 'include',
    body: JSON.stringify(credentials),
  });

  return response.ok ? await response.json() : null;
}

export async function requestPasswordResetAsync(email) {
  return requestWrapper(async () => await fetch(`${baseUrl}/api/users/password-reset`, {
    headers: {
      ...defaultHeaders,
      Email: email
    },
    method: 'POST',
  }));
}

export async function requestPasswordResetByUserIdAsync(id) {
  return await requestWrapper(async () =>
    await fetch(`${baseUrl}/api/users/password-reset/${id}`, {
      headers: {
        ...defaultHeaders,
      },
      method: 'POST',
    }));
}
